import { haversineKm } from './geo.js';
/**
 * Kennzahlen über alle Teilstrecken einer Runde. Der Server hängt ein `Leg`
 * erst bei der Landung an – wer gerade in der Luft ist, übergibt die laufende
 * Strecke als `pending`, damit die Zahlen während des Fluges nicht stehen
 * bleiben.
 */
export function routeStats(legs, pending) {
    const hops = [...legs.map((l) => ({ from: l.from, to: l.to }))];
    if (pending)
        hops.push(pending);
    const airports = new Set();
    let distanceKm = 0;
    for (const h of hops) {
        airports.add(h.from.iata);
        airports.add(h.to.iata);
        distanceKm += haversineKm(h.from, h.to);
    }
    return { flights: hops.length, airports: airports.size, distanceKm };
}
//# sourceMappingURL=stats.js.map